import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { styled, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Card from "../../components/Cards/Card";
import { useQlik } from "../../context/Qlik";
import NativeObject from "../../components/NativeObject/NativeObject";
import utils from "../../QlikUtils";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-evenly",
  width: "100%",
});

const LayoutCardWrapper = styled("div")({
  borderRadius: "16px",
  display: "flex",
  width: "100%",
  paddingRight: "10px",
});

function DetailDesktop({ app, config, filter }) {
  const { cards } = config.detail;
  const { title, tooltip, customRadio, legends, comboCharts } = cards[0];
  const visRef = useRef([]);

  const { setSwitchOnDemand } = useQlik();


  useEffect(() => {
    setSwitchOnDemand(false);
  }, []);

  return (
    <div className="app investments">
      <div className="appContent">
        <LayoutCardsWrapper>
          <LayoutCardWrapper style={{ height: "100%" }}>
            <Card
              exportTable
              app={app}
              exportContainer
              exportTableId="ayuN"
              header={{
                hardTitle: "Detalhamento",
              }}
              style={{ width: "100%", alignItems: "center" }}
            >
              <NativeObject
                app={app}
                key="ayuN"
                reference={{ id: "ayuN" }}
                style={{ marginTop: "20px" }}
              />
            </Card>
          </LayoutCardWrapper>
          {/* KAPI E GRAFICO CENTRAL */}
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

DetailDesktop.defaultProps = {
  app: null,
  config: {},
};

DetailDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DetailDesktop;
